import { createSlice } from "@reduxjs/toolkit";
import { DColumns } from "../../actions/data/DataDeclarations";
import {
  createLocation,
  userCreation, //<=== this should be in users reducer with all their actions
} from "../../actions/locations/locationsAsyncActions";

import { ObjectRowsTransform } from "../../../components/userLocations/multilocation/StepThreeMultiLoc";

import { SiteUsersConfigRows } from "../../actions/users/userTypes";

import { ActionValues } from "../grainTracker/grainTrackerTypes";
import { logOut } from "../layout";
import { DataSBFilterValues } from "../../actions/dataTable/DataTableTypes";

export interface CreateLocationStep {
  step: number;
  option: string;
  place: string;
  locationValidate: boolean;
}

export interface CreateNewSite {
  siteName: string;
  group: string[];
  siteAddress: string;
  longitude: number;
  latitude: number;
  identifier: string;
  countryName: string;
  createNewUsers: boolean;
}

export interface CreateUsersLocation {
  numberOfUserToCreate: number;
  usersNames: string;
  usersToCreate: string[];
}

export interface LocationInformation {
  address: string | null;
  altitude: number;
  countryName: string | null;
  createdAt: string;
  deletedAt: null | string;
  email: null | string;
  group: any;
  id: number;
  imageFileId: null | string;
  latitude: number;
  longitude: number;
  name: string;
  notes: null | string;
  orgId: number;
  primaryContactName: null | string;
  remoteId: null | string;
  siteLoginUsernamePrimitive: null | string;
  siteLoginsUserId: null | string;
  sitePassword: null | string;
  storageManagementEnabled: boolean;
  telephone: null | string;
  typeId: number;
  updatedAt: string | null;
}

export interface CreateLocationState {
  createLocationStep: CreateLocationStep;
  createNewSite: CreateNewSite;
  createUsers: CreateUsersLocation;
  searchValues: {
    sites: string;
    actions: string;
  };
  error: string;
  errorCreateUsers: string;
  errorCreateLocations: string;
  usersConfigRows: SiteUsersConfigRows[];
  rowsAlpha: SiteUsersConfigRows[];
  columns: any[];
  actionsValues: ActionValues[];
  loadingCreateLocation: boolean;
  createLocationSuccess: boolean;
  createUsersSuccess: boolean;
  MaximumNumberUsernamesCreationsLoc: number;
  tryToCreateSomething: boolean;
  csvResults: ObjectRowsTransform[];
  csvSize: number;
  multiLocationLoading: boolean;
  multiLocationCreatedSuccess: boolean;
  multiLocsCreated: number;
  multilocError: string;
  userSelectedAutocompleteStep2NoUsers: {
    allValuesSelected: boolean;
    valuesSelected: DataSBFilterValues[];
  };
  usersCreated: any[];
}

export const initialState: CreateLocationState = {
  createLocationStep: {
    step: 0,
    option: "",
    place: "",
    locationValidate: true,
  },
  createNewSite: {
    siteName: "",
    group: [],
    siteAddress: "",
    longitude: 0,
    latitude: 0,
    identifier: "",
    countryName: "",
    createNewUsers: true,
  },

  createUsers: {
    numberOfUserToCreate: 0,
    usersNames: "",
    usersToCreate: [],
  },

  searchValues: {
    sites: "",
    actions: "",
  },

  usersConfigRows: [],
  rowsAlpha: [],
  columns: [
    {
      field: "id",
      sortable: true,
      width: 100,
      alwaysHide: true,
    },
    {
      field: "username",
      sortable: true,
      width: 200,
      alwaysHide: false,
    },
    {
      field: "assignedSite",
      sortable: false,
      width: 240,
      alwaysHide: false,
    },
    {
      field: "assignedAction",
      sortable: false,
      width: 240,
      alwaysHide: false,
    },

    {
      field: "nomadUser",
      sortable: false,
      width: 200,
      alwaysHide: false,
    },
    {
      field: "actions",
      sortable: false,
      width: 200,
      alwaysHide: false,
    },
  ] as DColumns[],
  error: "",
  errorCreateLocations: "",
  errorCreateUsers: "",
  actionsValues: [{ name: "", id: 0 }],
  loadingCreateLocation: false,
  createLocationSuccess: false,
  createUsersSuccess: false,
  MaximumNumberUsernamesCreationsLoc: 0,
  tryToCreateSomething: false,
  csvResults: [],
  csvSize: 0,
  multiLocationCreatedSuccess: false,
  multiLocationLoading: false,
  multiLocsCreated: 0,
  multilocError: "",
  userSelectedAutocompleteStep2NoUsers: {
    allValuesSelected: false,
    valuesSelected: [],
  },

  usersCreated: [],
  //GrainTracker
};

export const CreateLocationSlice = createSlice({
  name: "CreateLocationReducer",
  initialState,
  reducers: {
    setUsersCreated(state, action) {
      return {
        ...state,
        usersCreated: action.payload,
      };
    },
    setValuesAutCompleteStep2(state, action) {
      return {
        ...state,
        userSelectedAutocompleteStep2NoUsers: action.payload,
      };
    },
    setMultiLocError(state, action) {
      return {
        ...state,
        multilocError: action.payload,
      };
    },
    setMultiLocsCreated(state, action) {
      return {
        ...state,
        multiLocsCreated: action.payload,
      };
    },
    setMultiLocationSuccess(state, action) {
      return {
        ...state,
        multiLocationCreatedSuccess: action.payload,
      };
    },
    setMultiLocationLoading(state, action) {
      return {
        ...state,
        multiLocationLoading: action.payload,
      };
    },
    setCsvSize(state, action) {
      return {
        ...state,
        csvSize: action.payload,
      };
    },
    setCSVResults(state, action) {
      return {
        ...state,
        csvResults: action.payload,
      };
    },
    setTryToCreate(state, action) {
      return {
        ...state,
        tryToCreateSomething: action.payload,
      };
    },
    setMaximumNumberFromUserCreationsLoc(state, action) {
      return {
        ...state,
        MaximumNumberUsernamesCreationsLoc: action.payload,
      };
    },
    setActionValues(state, action) {
      return {
        ...state,
        actionsValues: action.payload,
      };
    },
    setSearchValues(state, action) {
      return {
        ...state,
        searchValues: action.payload,
      };
    },
    setRowsAlpha(state, action) {
      return {
        ...state,
        rowsAlpha: action.payload,
      };
    },
    setColumns(state, action) {
      return {
        ...state,
        columns: action.payload,
      };
    },
    setUserConfigRows(state, action) {
      return {
        ...state,
        usersConfigRows: action.payload,
      };
    },
    setCreateUsersLoc(state, action) {
      return {
        ...state,
        createUsers: action.payload,
      };
    },
    setErrorCreateLoc(state, action) {
      return {
        ...state,
        error: action.payload,
      };
    },
    setCreateLocationStep(state, action) {
      return {
        ...state,
        createLocationStep: action.payload,
      };
    },

    CreateNewSiteSetValues(state, action) {
      return {
        ...state,
        createNewSite: action.payload,
      };
    },

    resetStateCreatLocUsers(state) {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(userCreation.pending, (state) => {
        state.loadingCreateLocation = true;
        state.createUsersSuccess = false;
        state.errorCreateUsers = "";
      })
      .addCase(userCreation.fulfilled, (state) => {
        state.loadingCreateLocation = false;
        state.createUsersSuccess = true;
      })
      .addCase(userCreation.rejected, (state, action) => {
        state.loadingCreateLocation = false;
        state.createUsersSuccess = false;
        state.errorCreateUsers = action.payload as string;
      });

    builder
      .addCase(createLocation.pending, (state) => {
        state.loadingCreateLocation = true;
        state.createLocationSuccess = false;
        state.errorCreateLocations = "";
      })
      .addCase(createLocation.fulfilled, (state) => {
        state.loadingCreateLocation = false;
        state.createLocationSuccess = true;
      })
      .addCase(createLocation.rejected, (state, action) => {
        state.loadingCreateLocation = false;
        state.createLocationSuccess = false;
        state.errorCreateLocations = action.payload as string;
      });

    builder.addCase(logOut, () => {
      return initialState;
    });
  },
});

export const {
  setUsersCreated,
  setValuesAutCompleteStep2,
  setMultiLocError,
  setMultiLocsCreated,
  setMultiLocationLoading,
  setMultiLocationSuccess,
  setCsvSize,
  setCSVResults,
  setTryToCreate,
  setMaximumNumberFromUserCreationsLoc,
  setActionValues,
  setSearchValues,
  setRowsAlpha,
  setColumns,
  setUserConfigRows,
  setCreateUsersLoc,
  setCreateLocationStep,
  CreateNewSiteSetValues,
  setErrorCreateLoc,
  resetStateCreatLocUsers,
} = CreateLocationSlice.actions;

export const CreateLocation = CreateLocationSlice.reducer;
